"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const classTabButton_1 = require("components/classTabButton");
const CheckboxList_1 = __importDefault(require("components/cosmos/checkbox-list/CheckboxList"));
const CheckboxListItem_1 = __importDefault(require("components/cosmos/checkbox-list/CheckboxListItem"));
const defaultClass_1 = __importDefault(require("components/defaultClass"));
const Html_1 = __importDefault(require("components/Html"));
const translate_1 = require("components/translate");
const shellContext_1 = require("contexts/shellContext");
const useShellContext_1 = require("hooks/useShellContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const classManager_1 = require("modules/classManager");
const content_1 = require("modules/content");
const ui_1 = require("modules/ui");
const ModuleEditorService_1 = __importDefault(require("../ModuleEditorService"));
const ClassesList = ({ t, selectedClassIds }) => {
    const [classes, setClasses] = (0, react_1.useState)([]);
    const { params: { id: moduleId } } = (0, react_router_dom_1.useRouteMatch)();
    const { isMembership, dispatchMembershipTabChange } = (0, useShellContext_1.useShellContext)();
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            try {
                const classes = await content_1.ClassesService.getAllClassesInfos();
                setClasses(classes);
            }
            catch (error) {
                ui_1.UiService.setAlertError('default_error');
            }
        };
        fetchData();
    }, []);
    (0, react_1.useEffect)(() => {
        const isNewModule = !moduleId;
        if (isNewModule) {
            const defaultClassIds = classes.flatMap(({ hashId, defaultClass }) => {
                return defaultClass ? [hashId] : [];
            });
            ModuleEditorService_1.default.setData({ classes: defaultClassIds });
        }
    }, [moduleId, classes]);
    const handleManageClassClick = (event) => {
        classManager_1.ClassReferrerUtil.setValue(classManager_1.NewClassReferrer.MODULE_EDITOR);
        if (isMembership) {
            event.preventDefault();
            dispatchMembershipTabChange(shellContext_1.MembershipTabs.Classes);
        }
    };
    const handleSelect = (event, classId) => {
        let newSelectedClassIds = [];
        if (event.target.checked) {
            newSelectedClassIds = [...selectedClassIds, classId];
        }
        else {
            newSelectedClassIds = selectedClassIds.filter((id) => id !== classId);
        }
        ModuleEditorService_1.default.setData({ classes: newSelectedClassIds });
    };
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            ModuleEditorService_1.default.setData({
                classes: classes.map(({ hashId }) => hashId)
            });
        }
        else {
            ModuleEditorService_1.default.setData({ classes: [] });
        }
    };
    const hasSelectedAll = classes.length > 0 && selectedClassIds.length === classes.length;
    return ((0, jsx_runtime_1.jsxs)("section", { className: "_mb-8", children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _justify-content-between _flex-column _flex-sm-row _align-items-start _align-items-sm-center", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { className: "hot-form__label _text-2 _font-weight-bold _text-gray-900 _mt-0", children: t('general.classes', { checkOnlineEvent: true }) }), (0, jsx_runtime_1.jsx)(Html_1.default, { children: t('module_editor.which_classes_v2', { checkOnlineEvent: true }) })] }), (0, jsx_runtime_1.jsx)(classTabButton_1.ClassTabButton, { className: "_mt-3 _mt-sm-0", onClick: handleManageClassClick })] }), (0, jsx_runtime_1.jsxs)(CheckboxList_1.default, { children: [(0, jsx_runtime_1.jsx)(CheckboxListItem_1.default, { label: t('general.select_all'), checked: hasSelectedAll, onChange: handleSelectAll }), classes.map((classInfo, index) => ((0, jsx_runtime_1.jsx)(CheckboxListItem_1.default, { checked: selectedClassIds.includes(classInfo.hashId), onChange: (event) => handleSelect(event, classInfo.hashId), label: (0, jsx_runtime_1.jsx)(defaultClass_1.default, { name: classInfo.name, isDefault: classInfo.defaultClass }), isLast: index === classes.length - 1 }, classInfo.hashId)))] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    selectedClassIds: stores.ModuleEditorStore.classes
})))(ClassesList);
